// Core Color Palette
export const colors = {
    primary: {
        main: '#2D3436', // Dark Gray
        light: '#636E72',
        dark: '#1E2527',
    },
    secondary: {
        main: '#0984E3', // Electric Blue
        light: '#74B9FF',
        dark: '#0770C0',
    },
    accent: {
        main: '#00B894', // Mint
        light: '#55EFC4',
        dark: '#00856B',
    },
    background: '#FFFFFF', // White
    text: '#2D3436', // Dark Gray
};

// Theme-specific color configurations
export const lightTheme = {
    primary: colors.primary.main,
    secondary: colors.secondary.main,
    accent: colors.accent.main,
    background: colors.background,
    text: colors.text,
    gradients: {
        primary: `linear-gradient(45deg, ${colors.primary.main} 30%, ${colors.secondary.main} 90%)`,
        secondary: `linear-gradient(45deg, ${colors.secondary.main} 30%, ${colors.accent.main} 90%)`,
        accent: `linear-gradient(45deg, ${colors.primary.main} 30%, ${colors.accent.main} 90%)`,
        hover: {
            primary: `linear-gradient(45deg, ${colors.primary.dark} 30%, ${colors.secondary.dark} 90%)`,
            secondary: `linear-gradient(45deg, ${colors.secondary.dark} 30%, ${colors.accent.dark} 90%)`,
            accent: `linear-gradient(45deg, ${colors.primary.dark} 30%, ${colors.accent.dark} 90%)`,
        },
    },
    particles: {
        color: colors.primary.main,
        links: colors.primary.main,
    },
};

export const darkTheme = {
    primary: '#FFFFFF',
    secondary: colors.secondary.light,
    accent: colors.accent.light,
    background: colors.primary.main,
    text: '#FFFFFF',
    gradients: {
        primary: `linear-gradient(45deg, #FFFFFF 30%, ${colors.secondary.light} 90%)`,
        secondary: `linear-gradient(45deg, ${colors.secondary.light} 30%, ${colors.accent.light} 90%)`,
        accent: `linear-gradient(45deg, ${colors.accent.light} 30%, #FFFFFF 90%)`,
        hover: {
            primary: `linear-gradient(45deg, #F1F2F6 30%, ${colors.secondary.main} 90%)`,
            secondary: `linear-gradient(45deg, ${colors.secondary.main} 30%, ${colors.accent.main} 90%)`,
            accent: `linear-gradient(45deg, ${colors.accent.main} 30%, #F1F2F6 90%)`,
        },
    },
    particles: {
        color: '#FFFFFF',
        links: '#FFFFFF',
    },
};

// Utility functions for color manipulation
export const colorUtils = {
    // Add alpha channel to hex color
    addAlpha: (hex, alpha) => {
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },

    // Create glass effect
    createGlassEffect: (baseColor, alpha = 0.9) => ({
        backgroundColor: colorUtils.addAlpha(baseColor, alpha),
        backdropFilter: 'blur(10px)',
        border: '1px solid',
        borderColor: colorUtils.addAlpha(baseColor, 0.3),
    }),

    // Create gradient
    createGradient: (startColor, endColor, angle = 45) =>
        `linear-gradient(${angle}deg, ${startColor} 30%, ${endColor} 90%)`,

    // Create shadow
    createShadow: (color, intensity = 'medium') => {
        const alphas = {
            light: [0.1, 0.15],
            medium: [0.15, 0.25],
            strong: [0.25, 0.4],
        };
        const [normalAlpha, hoverAlpha] = alphas[intensity];
        return {
            boxShadow: `0 8px 32px ${colorUtils.addAlpha(color, normalAlpha)}`,
            '&:hover': {
                boxShadow: `0 12px 48px ${colorUtils.addAlpha(color, hoverAlpha)}`,
            },
        };
    },
};
